export default __webpack_public_path__ + "4f0c79a353866c85de91d37139cd27a6.svg";